var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconFileFile = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 36 44"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#222",
  d: "M20.343 0a6 6 0 0 1 4.243 1.757l9.657 9.657A6 6 0 0 1 36 15.657V36a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8V8a8 8 0 0 1 8-8Zm0 2H8a6 6 0 0 0-6 6v28a6 6 0 0 0 6 6h20a6 6 0 0 0 6-6V15.657a4 4 0 0 0-1.172-2.829l-9.656-9.656A4 4 0 0 0 20.343 2M21 5a1 1 0 0 1 1 1v8h8a1 1 0 1 1 0 2h-9a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1"
})));
export default SvgIconFileFile;